
import { defineComponent, ref, onMounted, onUnmounted, computed } from 'vue'
import { useDayjs } from '@/core/hook/useDayjs'
import {
 NSelect,
 NButton,
 NSpace,
 NH2,
 NCard,
 NText,
 NIcon,
 NEmpty,
 NDivider
} from 'naive-ui'
import { TimeOutline } from '@vicons/ionicons5'
import { useI18n } from "vue-i18n";
export default defineComponent({
 components: {
  NSelect,
  NButton,
  NSpace,
  NH2,
  NCard,
  NText,
  NIcon,
  NEmpty,
  NDivider,
  TimeOutline
 },
 setup() {
  const {
   formattedNow,
   setTimezone,
   getTimezone,
   getTimezoneOptions,
   getUserTimezone,
   startAutoUpdate
  } = useDayjs()
   const { t, locale } = useI18n();
  // 使用當前時區作為初始值
  const selectedTimezone = ref(getTimezone().value)

  // 獲取帶有格式化標籤的時區選項
  const allTimezoneOptions = getTimezoneOptions()
  const timezoneOptions = ref(allTimezoneOptions)

  // 獲取本地時區名稱
  const localTimezoneName = computed(() => {
   const localTz = getUserTimezone()
   const option = allTimezoneOptions.find(opt => opt.value === localTz)
   return option ? option.label : localTz
  })

  // 獲取當前選中的時區名稱
  const currentTimezoneName = computed(() => {
   const option = allTimezoneOptions.find(opt => opt.value === selectedTimezone.value)
   return option ? option.label : selectedTimezone.value
  })

  // 自定義過濾器，支援多種關鍵字搜尋
  const customFilter = (pattern: string, option: any) => {
   if (!pattern) return true;

   const searchPattern = pattern.toLowerCase();

   // 檢查是否匹配城市、區域、偏移量或完整搜尋文字
   return option.searchText.includes(searchPattern) ||
    option.city.toLowerCase().includes(searchPattern) ||
    option.region.toLowerCase().includes(searchPattern) ||
    option.offset.toLowerCase().includes(searchPattern);
  }

  // 當前時間，自動更新
  const currentTime = formattedNow('YYYY-MM-DD HH:mm:ss (dddd)')

  // 更改時區
  const changeTimezone = (tz: string) => {
   if (tz) {
    setTimezone(tz)
   }
  }

  // 使用本地時區
  const useLocalTimezone = () => {
   const localTz = getUserTimezone()
   selectedTimezone.value = localTz
   setTimezone(localTz)
  }

  // 啟動時間自動更新
  let stopAutoUpdate: (() => void) | null = null

  onMounted(() => {
   // 初始化時使用瀏覽器本地時區
   useLocalTimezone()

   // 啟動時間自動更新
   stopAutoUpdate = startAutoUpdate(1000)
  })

  onUnmounted(() => {
   // 清理定時器
   if (stopAutoUpdate) {
    stopAutoUpdate()
   }
  })

  return {
   selectedTimezone,
   timezoneOptions,
   currentTime,
   changeTimezone,
   useLocalTimezone,
   customFilter,
   localTimezoneName,
   currentTimezoneName,
   t
  }
 }
})
